import type { AnchorRock, GoalDriveCreateRequest } from "@/api/drives";
import type { Brand } from "@/hooks/use-brands";

/** KPI Registry slugs and names, verbatim. A rep's own rock measures $ Sales only. */
export const PUSH_KPIS = [
  { slug: "sales.revenue", name: "$ Sales" },
  { slug: "revenue.total", name: "$ Revenue" },
] as const;
export type PushKpi = (typeof PUSH_KPIS)[number]["slug"];

/** Weekdays at 06:15 Eastern, after the morning brief. */
const DAILY = "15 6 * * 1-5";

/** A company rock covers every brand; a brand rock covers that brand and its tuck-ins. */
export function defaultBrands(rock: AnchorRock, brands: Brand[]): string[] {
  if (rock.is_company_rock || !rock.tenant_id) return brands.map((b) => b.id);
  return brands.filter((b) => b.id === rock.tenant_id || b.parent_id === rock.tenant_id).map((b) => b.id);
}

export function pushRequest(
  rock: AnchorRock,
  { kpi, target, brands, recipients }: { kpi: PushKpi; target: number; brands: string[]; recipients: string[] },
): GoalDriveCreateRequest {
  const name = PUSH_KPIS.find((k) => k.slug === kpi)?.name ?? "$ Sales";
  return {
    destination: "me",
    goal: {
      name: `Push: ${rock.title}`.slice(0, 200),
      goal: `${name} quarter to date reaches ${target.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 })} for ${rock.title}`.slice(0, 4000),
      anchor: { type: "rock", ref: rock.id },
      measure: {
        kpi_slug: kpi,
        band: { op: ">=", value: target },
        watch_slugs: [],
        window: "qtd",
        target,
        brands,
      },
      end_rule: null,
      watches: [],
      moves: {},
      lifetime: "standing",
      schedule_cron: DAILY,
      max_runs_per_day: 4,
      revenue_push: { recipient_profile_ids: recipients },
    },
  };
}
